"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/objectSpread2"));

require("core-js/modules/es6.function.name");

var _vuex = require("vuex");

var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));

var _SidebarItem = _interopRequireDefault(require("./SidebarItem"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    SidebarItem: _SidebarItem.default,
    Hamburger: _Hamburger.default
  },
  data: function data() {
    return {
      isOpened: false,
      activeName: '' //选中的菜单名称

    };
  },
  mounted: function mounted() {
    this.isOpened = this.sidebar.opened;
    this.activeName = this.$route.name;
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['permission_routers', 'sidebar'])), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  watch: {
    'sidebar.opened': function sidebarOpened(newV, oldV) {
      var _this = this;

      if (newV) {
        //延迟展示 防止频闪
        setTimeout(function () {
          _this.isOpened = true;
        }, 200);
      } else this.isOpened = newV;
    },
    $route: function $route(to, from) {
      this.activeName = to.name; //console.info('activeName', this.activeName)
    }
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    togglePanel: function togglePanel() {
      this.$store.commit("togglePanel");
    }
  }
};
exports.default = _default;